module.exports = __webpack_public_path__ + "img/ring_y_c_1_0@2x.3aec6e78.png";